export const allPermissions = [
  {
    name: 'Live Status',
    id: 'liveStatus',
    permissionArray: [{label:'view',value:'liveStatus_view'},{label:'modify',value:'liveStatus_modify'}]
  },
  {
    name: 'Analytics',
    id: 'analytics',
    permissionArray: [{label:'view',value:'analytics_view'},{label:'modify',value:'analytics_modify'}]
  },
  {
    name: 'Alarms',
    id: 'alarms',
    permissionArray: [{label:'view',value:'alarms_view'},{label:'modify',value:'alarms_modify'}]
  },
  {
    name: 'Charging Stations',
    id: 'chargingStations',
    permissionArray: [{label:'view',value:'chargingStations_view'},{label:'modify',value:'chargingStations_modify'}]
  },
  {
    name: 'Charge Point',
    id: 'chargePoint',
    permissionArray: [{label:'view',value:'chargePoint_view'},{label:'modify',value:'chargePoint_modify'}]
  },
  {
    name: 'RFID',
    id: 'rfid',
    permissionArray: [{label:'view',value:'rfid_view'},{label:'modify',value:'rfid_modify'}]
  },
  {
    name: 'EV Chargers model',
    id: 'evChargersModel',
    permissionArray: [{label:'view',value:'evChargersModel_view'},{label:'modify',value:'evChargersModel_modify'}]
  },
  {
    name: 'EV Vehicle',
    id: 'evVehicle',
    permissionArray: [{label:'view',value:'evVehicle_view'},{label:'modify',value:'evVehicle_modify'}]
  },
  {
    name: 'Manufacture',
    id: 'manufacture',
    permissionArray: [{label:'view',value:'manufacture_view'},{label:'modify',value:'manufacture_modify'}]
  },
  {
    name: 'Charging Transaction',
    id: 'chargingTransaction',
    permissionArray: [{label:'view',value:'chargingTransaction_view'},{label:'modify',value:'chargingTransaction_modify'}]
  },
  {
    name: 'Charge Logs',
    id: 'chargeLogs',
    permissionArray: [{label:'view',value:'chargeLogs_view'},{label:'modify',value:'chargeLogs_modify'}]
  },
  {
    name: 'Account Transactions',
    id: 'accountTransactions',
    permissionArray: [{label:'view',value:'accountTransactions_view'},{label:'modify',value:'accountTransactions_modify'}]
  },
  {
    name: 'Search Customer',
    id: 'searchCustomer',
    permissionArray: [{label:'view',value:'searchCustomer_view'},{label:'modify',value:'searchCustomer_modify'}]
  },
  {
    name: 'Customer List',
    id: 'customerList',
    permissionArray: [{label:'view',value:'customerList_view'},{label:'modify',value:'customerList_modify'}]
  },
  {
    name: 'Charging Tariff',
    id: 'chargingTariff',
    permissionArray: [{label:'view',value:'chargingTariff_view'},{label:'modify',value:'chargingTariff_modify'}]
  },
  {
    name: 'Assign Tariff',
    id: 'assignTariff',
    permissionArray: [{label:'view',value:'assignTariff_view'},{label:'modify',value:'assignTariff_modify'}]
  },
  {
    name: 'Tax',
    id: 'tax',
    permissionArray: [{label:'view',value:'tax_view'},{label:'modify',value:'tax_modify'}]
  },
  {
    name: 'Active Sessions',
    id: 'activeSessions',
    permissionArray: [{label:'view',value:'activeSessions_view'},{label:'modify',value:'activeSessions_modify'}]
  },
  {
    name: 'Start remote session',
    id: 'startRemoteSession',
    permissionArray: [{label:'view',value:'startRemoteSession_view'},{label:'modify',value:'startRemoteSession_modify'}]
  },
  {
    name: 'Email Notification',
    id: 'emailNotification',
    permissionArray: [{label:'view',value:'emailNotification_view'},{label:'modify',value:'emailNotification_modify'}]
  },
  {
    name: 'In app Notification',
    id: 'inAppNotification',
    permissionArray: [{label:'view',value:'inAppNotification_view'},{label:'modify',value:'inAppNotification_modify'}]
  },
  {
    name: 'Report',
    id: 'report',
    permissionArray: [{label:'view',value:'report_view'},{label:'modify',value:'report_modify'}]
  },
  {
    name: 'Admin Management',
    id: 'adminManagement',
    permissionArray: [{label:'view',value:'adminManagement_view'},{label:'modify',value:'adminManagement_modify'}]
  },
  {
    name: 'Role Management',
    id: 'roleManagement',
    permissionArray: [{label:'view',value:'roleManagement_view'},{label:'modify',value:'roleManagement_modify'}]
  },
  {
    name: 'Admin Activity',
    id: 'adminActivity',
    permissionArray: [{label:'view',value:'adminActivity_view'},{label:'modify',value:'adminActivity_modify'}]
  }
];


